import IgnoreButton from './view'

export default IgnoreButton
